export function isExternal(url: string): boolean {
  if (!url) {
    return false
  }
  try {
    const currentHost = useRequestURL().hostname
    const newUrl = new URL(url, `http://${currentHost}`)
    return newUrl.hostname !== currentHost
  } catch {
    return false
  }
}
